import styled from "styled-components";
// ContentFormatter is needed to to get styling from RCL
import {
  ContentFormatter,
  Type,
  DialogTitle,
  DialogTitleActions,
} from "@ebscois/react-component-library";

export const ReferencesAndResourcesFormatter = styled(ContentFormatter)`
  padding: 0 0 0 0;
  ul {
    margin-left: 0;
    & .li {
      &::before {
        content: "";
      }
      ${({ theme }) => `font-family: ${theme.font.family.base};`}
      list-style-type: none;
      padding: 0 0 1rem 0;
      line-height: 0.75rem;
    }
  }
  & .ResourceHeader {
    ${({ theme }) => `font-weight: ${theme.font.weight.bold};`}
    padding: 0 0 0.5rem 0;
  }

  & .ItemLine {
    ${({ theme }) => `font-family: ${theme.font.family.base};`}
    padding: 0 2rem 0 0;
  }

  & .extlinkhtml {
    ${({ theme }) => `color: ${theme.colors.anchor};`}
    text-decoration: none
  }
`;

export const ReferencesAndSectionWrapper = styled.div`
  padding: 0 0 2rem 2rem;
`;
export const StyledDialogTitle = styled(DialogTitle)`
  padding: 0.25rem 0.25rem 0 0;
  direction: rtl; /* Sticks the close button to the right end */
`;

export const StyledDialogTitleActions = styled(DialogTitleActions)`
  width: auto;
`;

export const Title = styled(Type)`
  padding: 0 0 1rem 0;
`;

export const SubTitle = styled(Type)`
  ${({ theme }) => `font-weight: ${theme.font.weight.bold};`}
`;
